export async function fetchDataDrugs(api_url, api_key) {
  let response = await fetch(api_url, {
    headers: {
      "app-key": api_key,
    },
  });
  let res = await response.json();
  return Object.values(res);
}

export async function fetchVocabulary(api_url, api_key) {
  let response = await fetch(api_url, {
    headers: {
      "app-key": api_key,
    },
  });
  let res = await response.json();
  return res;
}
